import { apiClient } from "../axiosClient";

export interface DownloadReportPayload {
  type: "web" | "social";
  email: string;
}

export const downloadAuditReport = async (
  payload: DownloadReportPayload
) => {
  const { data } = await apiClient.post(
    "/audit/download-report",
    payload
  );

  return data;
};